

<div class="letter-container-new">
  <header class="header">
    <!-- Letter Header Lock -->
    <div class="lock-block" *ngIf="global.isLetterTopLocked">
      <img class="lock-image" [src]="constants.assetsPath + '/img/icons/lock-purple-mid.svg'" />
    </div>

    <!-- Decision -->
    <div class="decision" [ngClass]="{
        active: areReasonsSelected(),
        green: decisionStatus === decisionsConst.upheld.id,
        red: decisionStatus === decisionsConst.cancel.id,
        blue: decisionStatus === decisionsConst.reqInfo.id,
        grey:
          decisionStatus === decisionsConst.bespokeLetter.id ||
          decisionStatus === decisionsConst.none.id
      }">
      <div class="pending decision-text" *ngIf="!areReasonsSelected()">
        <span>Response Master decision</span>
      </div>
      <div class="ready decision-text" *ngIf="areReasonsSelected()">

        <h3 (click)="isCreateBespokeLetter = false; openDecisionModal(changeDecisionModal)" id="lnkOpenDecision">
          {{ getDecisionText() }}
        </h3>
        <div class="info" triggers="mouseenter:mouseleave" placement="left" [ngbPopover]="letterCodeEvent">
          <img [src]="constants.assetsPath + '/img/icons/info-white.svg'" alt="info"
            *ngIf="letterEventCode.length > 0" />
        </div>
        <ng-template #letterCodeEvent>
          <div>
            {{ letterEventDescription }}
            <strong>{{ letterEventCode }}.</strong>
          </div>
        </ng-template>
      </div>
      <span *ngIf="hasEditLetterAccess" class="decision-edit"><button class="app-submit decision-edit-button"
          (click)="isCreateBespokeLetter = false; openDecisionModal(changeDecisionModal)">
          change decision
        </button></span>
    </div>
    
    <!-- Letter Toolbar -->
    <div class="letter-toolbar">
      <div class="toolbar-item" [ngClass]="{ gold: isCustomParagraphVisible }" (click)="toggleCustomParagraph()" id="lnkCustomParagraph">
        <span class="paragraph-top-link">
          custom paragraph
          <div class="number-bubble" [@bounceBubble]="bounceLettersBubbleState" *ngIf="customParagraphs.length > 0" id="number-bubble-paragraphs">
            {{ customParagraphs.length }}
          </div>
        </span>
      </div>
    
      <div class="toolbar-item" [ngClass]="{ gold: isCustomLetterVisible }" (click)="toggleCustomLetter()" id="lnkCustomLetter">
        <span class="letter-top-link">
          custom letter
          <div class="number-bubble" [@bounceBubble]="bounceLettersBubbleState" *ngIf="customLetters.length > 0" id="number-bubble-letters">
            {{ customLetters.length }}
          </div>
        </span>
      </div>
    
      <div class="toolbar-item" [ngClass]="{ gold: isCreateBespokeLetter && isModalSubmitted }" (click)="isCreateBespokeLetter = true; openDecisionModal(bespokeLetterModal)" id="lnkCreateBespokeLetter">
        <span class="letter-top-link">bespoke letter</span>
      </div>
    
      <div class="toolbar-item grow">
        <span>
          <select ng-model="selectedName" (change)="onLetterTextTypeChanged($event.target.value)" class="select-no-border" id="ddlLetterTextSets" aria-label="style">
            <option *ngFor="let textSet of letterTextTypes" [ngValue]="textSet.id" class="select-option">
              {{ textSet.description }}
            </option>
          </select>
        </span>
      </div>
    
      <div class="toolbar-item last">
        <span>
          <select ng-model="selectedName" (change)="onLetterTemplateChanged($event.target.value)" class="select-no-border" id="ddlLetterTemplates" aria-label="layout">
            <option *ngFor="let letterTemplate of letterTemplates" [ngValue]="letterTemplate.id" [selected]="letterTemplate.description === letterTemplatedSelected">
              {{ letterTemplate.description }}
            </option>
          </select>
        </span>
      </div>
    </div>
      
    <div class="bubble-speach-tooltip box-shadow" #paragraphsTooltip
      *ngIf="isParagraphTooltipVisible && customParagraphs.length > 0">
      <label class="question-label no-border checkbox" *ngFor="let paragraph of customParagraphs"
        [ngClass]="{ selected: paragraph.selected }" [ngbPopover]="customParagraphContent"
        placement="{{ tooltipPlacement }}" triggers="mouseenter:mouseleave">
        <span>{{ paragraph.id }} {{ paragraph.name }}</span>
        <input aria-label="" type="checkbox" [checked]="paragraph.selected"
          (change)="paragraph.selected = !paragraph.selected; onParagraphSelected(paragraph)" role="checkbox" />
        <ng-template #customParagraphContent>
          <div [innerHTML]="paragraph.instructions | linkify"></div>
        </ng-template>
      </label>
    </div>
      <!-- <div class="letter-toolbar">
        <ul>
          <li [ngClass]="{ gold: isCustomParagraphVisible }" (click)="toggleCustomParagraph()" id="lnkCustomParagraph">
            <span class="paragraph-top-link">custom paragraph
              <div class="number-bubble" [@bounceBubble]="bounceLettersBubbleState" *ngIf="customParagraphs.length > 0"
                id="number-bubble-paragraphs">
                {{ customParagraphs.length }}
              </div>
            </span>
          </li>

          <li [ngClass]="{ gold: isCustomLetterVisible }" (click)="toggleCustomLetter()" id="lnkCustomLetter">
            <span class="letter-top-link">custom letter
              <div class="number-bubble" [@bounceBubble]="bounceLettersBubbleState" *ngIf="customLetters.length > 0"
                id="number-bubble-letters">
                {{ customLetters.length }}
              </div>
            </span>
          </li>
          <li>
            <div [ngClass]="{ gold: isCreateBespokeLetter && isModalSubmitted }"
              (click)="isCreateBespokeLetter = true; openDecisionModal(bespokeLetterModal)" id="lnkCreateBespokeLetter">
              <span class="letter-top-link">bespoke letter</span>
            </div>
          </li>
          <li>
            <div>
              <span class="paragraph-label">
                <select ng-model="selectedName" (change)="onLetterTextTypeChanged($event.target.value)"
                  class="select-no-border" id="ddlLetterTextSets" aria-label="style">
                  <option *ngFor="let textSet of letterTextTypes" [ngValue]="textSet.id" class="select-option">
                    {{ textSet.description }}
                  </option>
                </select>
              </span>
            </div>
          </li>
          <li class="last">
            <div>
              <span class="paragraph-label">
                <select ng-model="selectedName" (change)="onLetterTemplateChanged($event.target.value)"
                  class="select-no-border" id="ddlLetterTemplates" style="line-height: 3vh" aria-label="layout">
                  <option *ngFor="let letterTemplate of letterTemplates" [ngValue]="letterTemplate.id"
                    [selected]="letterTemplate.description === letterTemplatedSelected">
                    {{ letterTemplate.description }}
                  </option>
                </select>
              </span>
            </div>
          </li>
        </ul>
      </div> -->

  </header>
  <main class="content">
    <!-- Letter Generation Error -->
    <div class="decision-letter-space">
      <div class="save-letter-label" *ngIf="isCopyToastShown"
        [ngClass]="{ hidden: letterGenerationError.length > 0 }">
        <span>
          Copied to clipboard!
          <!--<img [src]="constants.assetsPath + '/img/icons/disk-green.svg'" width="13" height="13" />-->
        </span>
      </div>

      <!--letter generation error-->
      <div id="letterGenerationErrors" class="label info red" *ngIf="letterGenerationError.length > 0">
        <div [innerHTML]="letterGenerationError"></div>
      </div>

      <!--letter decision bespokeLetter-->
      <div class="label info blue" *ngIf="decisionStatus === decisionsConst.bespokeLetter.id && areReasonsSelected()">
        <p>
          Response Master could not generate a letter based on your responses. Please check your
          answers to the questions. Alternatively, please click the Bespoke Letter button above to
          generate a bespoke letter or click the Custom Letter button to select a custom letter.
        </p>
      </div>
    </div>

    <!-- Letter -->
    <div class="letter" id="letter-container-id">
      <!-- Pending Letter -->
      <div class="letter-pending" *ngIf="!isLetterShown()">

        <div class="spinner-container" *ngIf="loadingState">
          <div class="rm-spinner-text">{{ loadingMessage }}</div>

          <ng-container *ngIf="!letterGenerationError; else showArrow">
            <div class="rm-spinner" [ngClass]="spinnerStyle"></div>
          </ng-container>
          <ng-template #showArrow>
            <div class="rm-spinner-error-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#4d4d4d" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </div>
          </ng-template>
        </div>
        <img [src]="constants.assetsPath + '/img/icons/pending-letter.svg'" alt="Letter" />
      </div>
      <!-- Ready Letter -->
      <div 
        *ngIf="isLetterShown() && !isEditMode"
        id="letter-ready-id" 
        class="letter-ready" 
        [innerHTML]="ckeditorContent | safe: 'html'">
      </div>
      <!-- Edit Letter -->
      <div class="letter-edit" id="letter-edit-id" *ngIf="isLetterShown() && isEditMode">
        <ckeditor [(ngModel)]="ckeditorContent" #letterCkeditor id="letter-ckeditor-id" name="letter-ckeditor-id"
          [config]="ckeConfig" debounce="500">
        </ckeditor>
      </div>
    </div>

    <input aria-label="hidden" type="text" id="document-helper-formatted" #documentHelperFormatted        [value]="ckeditorContent" />
    <input aria-label="hidden" type="text" id="document-helper" #documentHelper        [value]="clearStyle(ckeditorContent)" />
  </main>
  <footer class="footer">

      <!-- Buttons -->
      <div class="buttons">
        <button class="app-submit secondary" *ngIf="!isEditMode" [disabled]="!isLetterShown() || saveLetterLoading"
          (click)="open()" [attr.data-name]="'cancel'" id="btnCancel">
          <span [innerHTML]="'Cancel'"></span>
        </button>
        <button class="undo app-submit secondary" *ngIf="isEditMode" (click)="cancelEditDocument()"
          [attr.data-name]="'undo'" id="btnUndo">
          <span [innerHTML]="'Undo'"></span>
        </button>
        <button
          class="app-submit"
          [disabled]="!isLetterShown() || saveLetterLoading"
          [ngClass]="{ edit: isEditMode }"
          [attr.data-name]="isEditMode ? 'finish' : 'edit'"
          (click)="saveEditDocument()"
          id="btnSave">
          <span>{{ buttonLabel }}</span>
        </button>
        <div class="button copy" *ngIf="isLetterShown() && showCopyBtn" [ngClass]="{ active: showCopyOptions }"
          id="btnCopy" #copyLetterBtn>
          <span (click)="copyLetterWordFormat()" class="btn-label" [attr.data-name]="'copy'">copy</span>
          <span class="arrow" (click)="toggleShowCopyOptions()"></span>

          <span class="copy-block" *ngIf="showCopyOptions">
            <span class="option" (click)="copyLetter(true)">
              <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
              <span>Copy to <strong>clipboard</strong> as html</span>
            </span>
            <span class="option" (click)="copyLetter(false); saveToDoc(true)">
              <img [src]="constants.assetsPath + '/img/icons/microsoft-word-grey.svg'" />
              <span>Copy and edit in <strong>Word</strong> formatted text</span>
            </span>
            <span class="option" (click)="copyLetter(true); saveToDoc(false)">
              <img [src]="constants.assetsPath + '/img/icons/microsoft-word-grey.svg'" />
              <span>Copy and edit in <strong>Word</strong> unformatted text</span>
            </span>
            <span class="copy-block-trial" *ngIf="clipboardTrialEnabled">
              <span class="option" (click)="copyLetter(true, 'HtmlRtfPlain')">
                <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
                <span>Copy to <strong>clipboard</strong> as html + RTF (trial)</span>
              </span>
              <span class="option" (click)="copyLetter(true, 'RtfPlain')">
                <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
                <span>Copy to <strong>clipboard</strong> as RTF only (trial)</span>
              </span>
              <span class="option" (click)="copyLetter(true, 'PlainStructured')">
                <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
                <span>Copy to <strong>clipboard</strong> as structured plain text (trial)</span>
              </span>
              <span class="option" (click)="copyLetter(true, 'LegacyExecCommandRtf')">
                <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
                <span>Copy to <strong>clipboard</strong> as RTF, legacy method (trial)</span>
              </span>
              <span class="option" (click)="copyLetter(true, 'NativeSelectionCopy')">
                <img [src]="constants.assetsPath + '/img/icons/clipboard-grey.svg'" />
                <span>Copy to <strong>clipboard</strong> via native selection (trial)</span>
              </span>
              <span class="option" (click)="saveToRtf(true)">
                <img [src]="constants.assetsPath + '/img/icons/microsoft-word-grey.svg'" />
                <span>Copy and edit in <strong>Word</strong> from RTF (trial)</span>
              </span>
            </span>
          </span>
        </div>

        <button
          *ngIf="isLetterShown() && showCopyBtn && showCopyToNpsFab"
          type="button"
          class="copy-to-nps-fab"
          title="Copy letter to NPS"
          (click)="copyToNps(true)">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M4 2.5H12.5V9.5H19.5V21.5H8.5V18.5" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M12.5 2.5L19.5 9.5H12.5V2.5Z" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/>
            <rect x="4" y="9.5" width="9" height="12" rx="0.5" stroke="#ffffff" stroke-width="1.5"/>
            <line x1="6.5" y1="13.5" x2="10.5" y2="13.5" stroke="#ffffff" stroke-width="1.3" stroke-linecap="round"/>
            <line x1="6.5" y1="16.5" x2="10.5" y2="16.5" stroke="#ffffff" stroke-width="1.3" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="clear"></div>
      </div>

      <!-- Terms and Conditions Popover -->
      <div class="terms">
        <button type="button" 
          class="btn btn-outline-secondary me-2 terms-link" 
          [ngbPopover]="popContent"
          [popoverTitle]="popTitle">
          <!-- terms and conditions -->
          <img
          [src]="constants.assetsPath + '/img/terms.png'"
          alt="terms and conditions"
          class="terms-icon"/>
        </button>
        <ng-template #popContent>The copyright to the text that Response Master generates is owned by Barbour Logic. Using or
          copying Response Master text is subject to Barbour Logic's
          <a [routerLink]="['/terms-conditions']">terms and conditions</a>. By using Response Master you
          agree to these terms and conditions.</ng-template>
        <ng-template #popTitle>Terms and Conditions</ng-template>        
      </div>
  </footer>
</div>


<ng-template #changeDecisionModal let-c="close" let-d="dismiss">
  <div class="modal-container decision-modal">
    <div class="close-icon white" (click)="onCloseModal()"></div>
    <change-decision
      (changeDecision)="onSubmitChangeDecision($event)"
      (closeModal)="onCloseModal()"
      [decision]="decisionStatus"
    ></change-decision>
  </div>
</ng-template>
<ng-template #bespokeLetterModal let-c="close" let-d="dismiss">
  <div class="modal-container bespoke-modal">
    <div class="close-icon white" (click)="onCloseModal()"></div>
    <bespoke-letter
      (submitBespokeLetter)="onSubmitBespokeLetter($event)"
      (closeModal)="onCloseModal()"
      [ckeConfig]="ckeConfig"
      [decision]="decisionStatus"
    ></bespoke-letter>
  </div>
</ng-template>

<kendo-dialog *ngIf="showCancelLetterDialog" (click)="open()" (close)="close()">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em">
      <span class="k-icon k-i-warning k-icon-md"></span> Cancel letter?
    </div>
  </kendo-dialog-titlebar>
  <p style="margin: 30px; text-align: center">Are you sure you want to cancel this letter?</p>
  <kendo-dialog-actions>
    <button kendoButton class="kendo-dialog-button" (click)="close('no')">No</button>
    <button kendoButton class="kendo-dialog-button" (click)="cancelEditDocument()">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
